import { Controller, useFormContext } from 'react-hook-form';
import { Input, InputProps } from '@ds';

interface ControlledInputProps extends InputProps {
  name: string;
}

export const ControlledTextInput = ({ name, ...props }: ControlledInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, ...field }, fieldState: { invalid, error } }) => (
        <Input
          type="text"
          isInvalid={invalid}
          errorMessage={error?.message}
          value={value || ''}
          {...field}
          {...props}
        />
      )}
    />
  );
};
